{
  "headings": {
    "start": "Comenzar",
    "end": "Finalizar",
    "duration": "Duro.",
    "zero": "Cero +/-",
    "activity": "Actividad",
    "location_space": "Ubicación/espacio"
  },
  "actions": {
    "insert_row_below": "Inserte la fila a continuación",
    "insert_row_below_alt": "Un icono que muestra la fila de inserción inferior",
    "insert_row_above": "Inserte la fila por encima",
    "insert_row_above_alt": "Un icono que muestra la fila de inserción en la parte superior",
    "export_as_excel": "Exportar como Excel"
  },
  "activity": {
    "start": "inicia",
    "zero": "TIEMPO CERO"
  },
  "deleting": {
    "deleting_affects_all_instances": "La eliminación afecta a todas las instancias",
    "delete_activity_description_1": "Al eliminar esta actividad, también se eliminarán todas las instancias en las que esté configurada para repetirse otros días",
    "delete_activity_description_2": "Si prefieres simplemente editar la configuración de repetición en lugar de eliminarla, haz clic en la columna de inicio"
  },
  "add": {
    "Event unit": "Añade un elemento programado",
    "Activity": "Agregar actividad"
  },
  "done": "Listo",
  "export_form": {
    "title": "Exportar DCAS",
    "days_to_export": "Días para exportar",
    "all_days": "Todos los días",
    "all_days_desc": "Exporte todas las tablas DCAS de este lugar a un único archivo de Excel",
    "selected_day": "Día seleccionado",
    "selected_day_desc": "Exporte el DCAS seleccionado a un archivo de Excel"
  }
}